import React, { useState } from 'react';
import { CalendarEvent, TimeSlot } from '../../types/calendar';
import { EventPill } from './EventPill';
import { Sparkles } from 'lucide-react';
interface CalendarMonthViewProps {
  events: CalendarEvent[];
  huecosDeOro: TimeSlot[];
  currentDate: Date;
  onSlotClick: (date: Date) => void;
  onEventClick: (event: CalendarEvent) => void;
}
export function CalendarMonthView({
  events,
  huecosDeOro,
  currentDate,
  onSlotClick,
  onEventClick
}: CalendarMonthViewProps) {
  const [draggedEvent, setDraggedEvent] = useState<CalendarEvent | null>(null);
  const daysInMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay();
  // Adjust for Monday start (0 = Monday, 6 = Sunday)
  const startOffset = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1;
  const days = Array.from({
    length: 42
  }, (_, i) => {
    const dayNumber = i - startOffset + 1;
    const isCurrentMonth = dayNumber > 0 && dayNumber <= daysInMonth;
    const date = new Date(currentDate.getFullYear(), currentDate.getMonth(), dayNumber);
    return {
      dayNumber,
      isCurrentMonth,
      date
    };
  });
  const getEventsForDay = (date: Date) => {
    return events.filter(e => {
      const eDate = new Date(e.start);
      return eDate.getDate() === date.getDate() && eDate.getMonth() === date.getMonth() && eDate.getFullYear() === date.getFullYear();
    });
  };
  const getHuecosForDay = (date: Date) => {
    return huecosDeOro.filter(h => {
      const hDate = new Date(h.start);
      return hDate.getDate() === date.getDate() && hDate.getMonth() === date.getMonth() && hDate.getFullYear() === date.getFullYear();
    });
  };
  const handleDragStart = (e: React.DragEvent, event: CalendarEvent) => {
    setDraggedEvent(event);
    e.dataTransfer.effectAllowed = 'move';
  };
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };
  const handleDrop = (e: React.DragEvent, date: Date) => {
    e.preventDefault();
    if (draggedEvent) {
      // In a real app, this would trigger the confirmation modal and update the event
      console.log(`Moved event ${draggedEvent.title} to ${date.toISOString()}`);
      // Simulate toast (handled by parent or global state in real app)
      alert('¿Confirmar nueva hora? (Simulado)');
      setDraggedEvent(null);
    }
  };
  const weekDays = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
  return <div className="card overflow-hidden flex flex-col h-full" data-id="element-178">
      <div className="grid grid-cols-7 border-b border-white/5 bg-growthly-panel" data-id="element-179">
        {weekDays.map(day => <div key={day} className="py-2 text-center text-[12px] font-medium text-growthly-muted" data-id="element-180">
            {day}
          </div>)}
      </div>

      <div className="grid grid-cols-7 flex-1 auto-rows-fr" data-id="element-181">
        {days.map((day, idx) => {
        const dayEvents = day.isCurrentMonth ? getEventsForDay(day.date) : [];
        const dayHuecos = day.isCurrentMonth ? getHuecosForDay(day.date) : [];
        const hasEvents = dayEvents.length > 0;
        return <div key={idx} className={`min-h-[100px] border-b border-r border-white/5 p-1 relative transition-colors ${!day.isCurrentMonth ? 'bg-growthly-bg/50 opacity-50' : hasEvents ? 'bg-white/[0.02]' : 'hover:bg-white/[0.02] cursor-pointer'}`} onClick={() => day.isCurrentMonth && onSlotClick(day.date)} onDragOver={handleDragOver} onDrop={e => day.isCurrentMonth && handleDrop(e, day.date)} data-id="element-182">
              {day.isCurrentMonth && <span className={`text-[12px] font-medium p-1 ${day.date.toDateString() === new Date().toDateString() ? 'bg-growthly-text text-growthly-bg rounded-full w-6 h-6 flex items-center justify-center mb-1' : 'text-growthly-muted'}`} data-id="element-183">
                  {day.dayNumber}
                </span>}

              <div className="mt-1 space-y-1" data-id="element-184">
                {dayEvents.slice(0, 3).map(event => <div key={event.id} draggable onDragStart={e => handleDragStart(e, event)} className="cursor-grab active:cursor-grabbing" data-id="element-185">
                    <EventPill event={event} onClick={e => {
                e.stopPropagation();
                onEventClick(event);
              }} data-id="element-186" />
                  </div>)}
                {dayEvents.length > 3 && <div className="text-[10px] text-growthly-muted px-1" data-id="element-187">
                    +{dayEvents.length - 3} más
                  </div>}
              </div>

              {dayHuecos.length > 0 && dayEvents.length === 0 && <div className="absolute inset-2 border-2 border-dashed border-growthly-green/25 bg-growthly-green/5 rounded-md flex items-center justify-center pointer-events-none" title="Slot recomendado según disponibilidad del setter y conversion histórico" data-id="element-188">
                  <Sparkles className="w-4 h-4 text-growthly-green/50" data-id="element-189" />
                </div>}
            </div>;
      })}
      </div>
    </div>;
}